export default function handleFileUploadAttempt({ fileForm, fileInputName, uploadCallback, fileTooLargeHandler }) {
  const MAX_SIZE = 15728640
  const data = new FormData(fileForm)
  const file = data.get(fileInputName)
  if (file.size > MAX_SIZE) {
    fileTooLargeHandler()
  } else {
    uploadCallback(file)
  }

  fileForm.reset()
}
